import { BoxTruckLoadsAction, BoxTruckLoadsWsMessage } from '@numeo/types'
import { WsMessageCategory } from '@numeo/types-core'

/**
 * Box Truck Loads live feed. The loadboard holds its rows in React local state (not Redux), so — like
 * agentic-hub's source-status events — we bridge the socket event to the feature via a window
 * CustomEvent that `useBoxTruckLoads` listens for and prepends to its list.
 */
export const handleBoxTruckLoadsMessages = (message: BoxTruckLoadsWsMessage): boolean => {
    if (message.categoryType !== WsMessageCategory.BoxTruckLoads) return false
    try {
        const data = message.data
        // The new-posting broadcast is for the mobile app. A web board gets its live rows from its own live-search
        // subscription, which the server matches; this broadcast carries no coordinates to judge a lane by.
        if (data?.action === BoxTruckLoadsAction.LOADS_CREATED) return true
        if (data?.action === BoxTruckLoadsAction.BID_PLACED && data.bid) {
            // Structured detail: `{ bid, load }`. Keeps the bid a clean LoadBid (consumers store it in their
            // bids map, so we must NOT pollute it with the full load) while carrying the load the notification
            // uses to open the drawer with no fetch.
            window.dispatchEvent(new CustomEvent('box-truck:bid-placed', { detail: { bid: data.bid, load: data.load } }))
            return true
        }
        if (data?.action === BoxTruckLoadsAction.OPERATOR_BID_EMAIL_SENT && data.bid) {
            window.dispatchEvent(new CustomEvent('box-truck:operator-bid-email-sent', { detail: data.bid }))
            return true
        }
        if (data?.action === BoxTruckLoadsAction.SMS_RECEIVED && data.message) {
            // Something new in a thread — a driver's reply, or a message the tenant wrote in the Quo
            // app, which reaches us the same way. The SMS page appends it to an open thread and badges
            // the row otherwise; it holds its state locally, so the bridge is a window event like the
            // loadboard's.
            window.dispatchEvent(new CustomEvent('box-truck:sms-received', { detail: data }))
            return true
        }
        return false
    } catch (error) {
        console.error('Error handling box-truck-loads message:', error)
        return false
    }
}
